// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"81f09a27","130":"d98b4e85","202":"96f56062","406":"668f46cc","550":"c12177ec","762":"212d9b70","767":"a6276bd9"}[chunkId] + ".chunk.js";
};